import React, { useState, useMemo } from "react";
import { useTheme } from "../config/ThemeContext";

const LiberoFixDialog = ({
  team,
  matchId,
  setNumber,
  activeLiberoId,
  replacedPlayerId,
  playerMap,
  rotation,
  onClose,
  socket,
  actionCode
}) => {
  const theme = useTheme();
  const teamPlayers = playerMap?.[team] || {};
  const benchPlayers = Object.keys(teamPlayers).filter(
    id => !rotation.includes(id)
  );

  const eligibleReplacements = useMemo(() => {
    return benchPlayers.filter(id =>
      teamPlayers[id]?.position?.toLowerCase() !== "libero"
    );
  }, [benchPlayers, teamPlayers]);

  const [selectedReplacement, setSelectedReplacement] = useState(replacedPlayerId);

  const handleConfirm = () => {
    if (!selectedReplacement) return;

    socket.emit("resolveLiberoRotation", {
      matchId,
      setNumber,
      team,
      replacementPlayerId: selectedReplacement,
      actionCode
    });

    onClose();
  };

  return (
    <div className="max-w-xl mx-auto mt-8 bg-white border border-slate-300 rounded-lg shadow-lg p-6">
      <h2 className="text-xl font-bold mb-4 text-center">Libero Rotation Blocked</h2>

      <p className="text-center mb-4 text-sm text-gray-600">
        Libero <span className="font-semibold text-yellow-700">
          #{teamPlayers[activeLiberoId]?.shirtNumber} {teamPlayers[activeLiberoId]?.shirtName}
        </span> cannot rotate into the front row.
      </p>

      <label className="block text-sm font-medium mb-2 text-gray-700">
        Select replacement:
      </label>

      <select
        value={selectedReplacement}
        onChange={(e) => setSelectedReplacement(e.target.value)}
        className={`w-full border rounded-md px-3 py-2 mb-4 ${theme.primary.border} ${theme.primary.focusRing} ${theme.primary.text}`}
      >
        {eligibleReplacements.map((id) => (
          <option key={id} value={id}>
            #{teamPlayers[id]?.shirtNumber} – {teamPlayers[id]?.shirtName}
          </option>
        ))}
      </select>

      <div className="flex justify-end gap-4 mt-4">
        <button
          className={theme.buttons.tertiary}
          onClick={onClose}
        >
          ❌ Cancel
        </button>
        <button
          className={theme.buttons.primary}
          onClick={handleConfirm}
        >
          ✅ Confirm Replacement
        </button>
      </div>
    </div>
  );
};

export default LiberoFixDialog;
